var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-panel"},[(_vm.$slots.search)?_c('div',{staticClass:"search-area"},[_vm._t("search")],2):_vm._e(),_vm._v(" "),(_vm.$slots.sub)?_c('div',{staticClass:"sub-area"},[_vm._t("sub")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-area"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }